import PublicHolidayListModelBase from '../_generated/modelBases/public-holiday-list-model-base';

export default class PublicHolidayListModel extends PublicHolidayListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
